import styled from 'styled-components';
import { Button } from 'antd';
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const StyledButton = styled(Button)`
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 8px 16px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  border: 1px solid ${(props) => getThemeValue(props, '#718096', '#d9d9d9')} !important;
  background-color: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
  box-shadow: ${(props) => getThemeValue(props,'0 1px 2px rgba(0, 0, 0, 0.3)','0 1px 2px rgba(0, 0, 0, 0.1)')} !important;
  transition: all 0.2s ease !important;

  &:hover {
    border-color: ${(props) => getThemeValue(props, '#718096', '#40a9ff')} !important;
    background-color: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
  }

  .anticon {
    color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
  }
`;

export const DropdownContainer = styled.div`
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  border-radius: 6px !important;
  padding: 8px !important;
  width: 135px !important;
  box-shadow: ${(props) => getThemeValue(props, '0 4px 12px rgba(0, 0, 0, 0.5)','0 4px 12px rgba(0, 0, 0, 0.15)')} !important;
  border: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const OptionItem = styled.div<{ isSelected: boolean; theme?: DefaultTheme }>`
  width: 100%;
  padding: 8px 16px;
  text-align: left;
  cursor: pointer;
  background-color: ${(props) => props.isSelected ? getThemeValue(props, '#4a5568', '#e6f4ff') : 'transparent'} !important;
  color: ${(props) => props.isSelected ? getThemeValue(props, '#ffffff', '#2d6cca') : getThemeValue(props, '#ffffff', '#262626')} !important;
  font-weight: ${(props) => (props.isSelected ? '600' : 'normal')} !important;
  transition: all 0.2s ease !important;
  border-radius: 4px !important;

  &:hover {
    background-color: ${(props) => getThemeValue(props, '#4a5568', '#e6f4ff')} !important;
    color: ${(props) => getThemeValue(props, '#ffffff', '#2d6cca')} !important;
  }
`;

export const ButtonText = styled.span`
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;
